import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["active", "insideRefs"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useValueRef, useElementForkRef } from '@cian/react-utils';
/**
 * Компонента для обработки клика снаружи children
 *
 * Умеет принимать ссылки на дополнительные DOM-ноды которые не будут считаться наружними
 *
 * Не рендерит дополнительных элементов и оберток
 *
 * @export
 * @param {IOutsideProps} props
 * @returns
 */
export function Outside(_ref) {
  var _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    _ref$insideRefs = _ref.insideRefs,
    insideRefs = _ref$insideRefs === void 0 ? [] : _ref$insideRefs,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * Запоминаем пропсы для того чтобы не переподписываться на клик
   * Переподписка может нарушить порядок вызова обработчиков относительно React-дерева
   * Это просто нежелательно
   */
  var propsRef = useValueRef(_objectSpread({
    active: active,
    insideRefs: insideRefs
  }, rest));
  var _useElementForkRef = useElementForkRef(rest.children),
    _useElementForkRef2 = _slicedToArray(_useElementForkRef, 2),
    children = _useElementForkRef2[0],
    childrenRef = _useElementForkRef2[1];
  React.useEffect(function () {
    var handleDocumentClick = function handleDocumentClick(event) {
      var currentProps = propsRef.current;
      if (!currentProps.active) {
        return;
      }
      var isInside = [childrenRef].concat(_toConsumableArray(currentProps.insideRefs)).some(function (_ref2) {
        var current = _ref2.current;
        return current && current.contains(event.target);
      });
      if (!isInside && currentProps.active) {
        currentProps.onOutside();
      }
    };
    document.addEventListener('click', handleDocumentClick, {
      capture: true
    });
    return function () {
      document.removeEventListener('click', handleDocumentClick, {
        capture: true
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return children;
}